import { SPLASH_LOGO_SRC } from '@app/core/splash/splash-screen';
import '@app/core/splash/splash-screen.css';
import { FatalError } from '@mi-front/ui';

/**
 * Branded full-page fatal error surface used by the app ErrorBoundary.
 * Visual language matches SplashLoader / LoginErrorScreen.
 * Preview with `?preview_fatal_error` (see FatalErrorPreviewGate).
 */
export function FatalErrorScreen() {
  return (
    <div className="mi-splash">
      <div className="mi-splash__wash" aria-hidden />
      <div className="mi-splash__content mi-splash__content--enter mi-splash__content--error">
        <img className="mi-splash__logo" src={SPLASH_LOGO_SRC} alt="MediaInbox logo" />
        <FatalError />
      </div>
    </div>
  );
}
